import { API_VERSION, SHIPOWNER_API_BASE } from '../constants/api'
import { createInstance } from './index.api'

const instance = createInstance({
  baseURL: `${SHIPOWNER_API_BASE}${API_VERSION}crm/`,
  responseType: 'json',
})

export default instance
